import styled from 'styled-components/macro'

export const Canvas = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
`
